import { render, staticRenderFns } from "./Account_code.vue?vue&type=template&id=342b334e&"
import script from "./Account_code.vue?vue&type=script&lang=js&"
export * from "./Account_code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports